import { filmInfo, navLinks } from "@/mocks/movie";

export default function Footer() {
  const goTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-10 md:gap-12">
          <div>
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                {filmInfo.title}
              </span>
            </div>
            <p className="mt-5 text-sm text-background-100/70 leading-relaxed max-w-md">
              本站围绕《岳母的诱惑》整理剧情简介、角色图鉴、主创阵容、观众评价与观影指南，
              帮助观众在一页之内了解这部家庭伦理剧情片的完整信息。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {filmInfo.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 rounded-full bg-background-50/10 text-background-100/80 text-xs border border-background-50/15"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">页面导航</h3>
            <ul className="mt-5 grid grid-cols-2 gap-2">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <button
                    type="button"
                    onClick={() => goTo(link.id)}
                    className="text-sm text-background-100/70 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">影片信息</h3>
            <ul className="mt-5 space-y-3 text-sm text-background-100/70">
              <li className="flex items-center gap-2">
                <i className="ri-calendar-line text-accent-300"></i>
                {filmInfo.year} · {filmInfo.region}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-300"></i>
                {filmInfo.duration}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-film-line text-accent-300"></i>
                {filmInfo.genre}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-star-fill text-accent-400"></i>
                综合评分 {filmInfo.rating}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-background-100/50">
            © {filmInfo.year} {filmInfo.title} · 本站内容仅用于影片信息整理与观影参考
          </p>
          <p className="text-xs text-background-100/50">
            请在合法合规渠道观看正版内容 · 建议 18 岁以上观众浏览
          </p>
        </div>
      </div>
    </footer>
  );
}